import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Feedback } from 'src/classes/feedback.model';
import { PERIOD, RESULT_STORE_ENPOINTS } from './constants';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {


  private authenticated: boolean = false;
  public user: { username: string; displayName: string; id: string } | undefined = undefined;
  public feedback: Feedback[];

  constructor(private http: HttpClient) { }

  updateAuthentication(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.API_URL + '/user', { withCredentials: true }).toPromise().then((res: any) => {
        this.authenticated = res.authenticated;
        this.user = res.user;
        resolve(true);
      }).catch((reason) => {
        this.authenticated = false;
        resolve(false);
      });
    });
  }

  public isAuthenticated() {
    return this.authenticated;
  }

  public getGeographicTrafficMapData(period): Promise<any> {
    return new Promise((resolve, reject) => {
      const now = new Date();
      let from = (period === PERIOD.MONTH) ? now.setMonth(now.getMonth() - 12) : now.setDate(now.getDate() - 8);
      from = Math.floor(from / 1000);
      const url = `${environment.API_URL}${RESULT_STORE_ENPOINTS.GEOGRAPHIC_TRAFFIC_FREQUENCY}?from=${from}`;
      this.http.get(url).toPromise().then((res: any) => {
        resolve(res);
      }).catch((reason) => {
        console.log(reason);
        reject(false);
      });
    });
  }

  public getTimeChartData(resultStoreEndpoint, period): Promise<any> {
    return new Promise((resolve, reject) => {

      const now = new Date();
      let from = (period === PERIOD.MONTH) ? now.setMonth(now.getMonth() - 12) : now.setDate(now.getDate() - 8);
      from = Math.floor(from / 1000);
      const url = `${environment.API_URL}${resultStoreEndpoint}?period=${(period === PERIOD.WEEK ? PERIOD.DAY : period)}&from=${from}`;

      this.http.get(url).toPromise().then((res: any) => {
        if (period === PERIOD.WEEK) {
          // analysis results are sent in UTC (or GMT)
          // convert this to local timezone
          resolve(
            res.map(r => {
              const localDate = new Date(r.label + " 10:00:00 PM UTC");
              const year = localDate.getFullYear();
              const month = localDate.getMonth() + 1;
              const date = localDate.getDate();
              return {
                data: r.data,
                label: year + "-" + (month <= 9 ? "0" + month : month) + "-" + date
              };
            })
          );
        } else {
          resolve(res);
        }

      }).catch((reason) => {
        console.log(reason);
        reject(false);
      });
    });
  }

  public getFrequencyRatioChartData(resultStoreEndpoint, period): Promise<any> {
    return new Promise((resolve, reject) => {
      const now = new Date();
      let from = (period === PERIOD.MONTH) ? now.setMonth(now.getMonth() - 12) : now.setDate(now.getDate() - 8);
      from = Math.floor(from / 1000);
      const url = `${environment.API_URL}${resultStoreEndpoint}?from=${from}`;

      this.http.get(url).toPromise().then((res: any) => {
        console.log('in administration.service line 103', res);
        if (res.length > 0) {
          // find the label from the object keys
          const keys = Object.keys(res[0]);
          const label = keys.filter(k => (k !== "count" && k !== "percent"))[0];
          resolve(res.map(r => ({ label: r[label], data: r["percent"] })));
        } else {
          resolve([]);
        }
      }).catch((reason) => {
        console.log(reason);
        reject(false);
      });
    });
  }

  public getLastFiveDaysSessionIds(): Promise<any> {
    return new Promise((resolve, reject) => {
      // const noOfDays = 30;
      // const now = new Date();
      // const from = Math.floor((now.setDate(now.getDate() - (noOfDays + 1))) / 1000); commented out to get all sessionIds
      const url = `${environment.API_URL}${RESULT_STORE_ENPOINTS.SESSION_IDS}`;

      this.http.get(url).toPromise().then((res: any) => {
        resolve(res);
      }).catch((reason) => {
        console.log(reason);
        reject(false);
      });
    });
  }

  public getTaskModelForSessionId(sessionId): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = `${environment.API_URL}${RESULT_STORE_ENPOINTS.TASK_MODEL}?sessionId=${sessionId}`;
      this.http.get(url).toPromise().then((res: any) => {
        resolve(res);
      }).catch((reason) => {
        console.log(reason);
        reject(false);
      });
    });
  }

  public getFeedbackAnalysis(period): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const now = new Date();
      let from = (period === PERIOD.MONTH) ? now.setMonth(now.getMonth() - 12) : now.setDate(now.getDate() - 9);
      from = Math.floor(from / 1000);

      try {

        const wasHelpfulResponse = await this.http.get(
          `${environment.API_URL}${RESULT_STORE_ENPOINTS.FEEDBACK_WAS_HELPFUL_FREQUENCY}?from=${from}`
        ).toPromise();

        const uiIsGoodResponse = await this.http.get(
          `${environment.API_URL}${RESULT_STORE_ENPOINTS.FEEDBACK_UI_IS_GOOD_FREQUENCY}?from=${from}`
        ).toPromise();

        const iWillUseItResponse = await this.http.get(
          `${environment.API_URL}${RESULT_STORE_ENPOINTS.FEEDBACK_I_WILL_USE_IT_FREQUENCY}?from=${from}`
        ).toPromise();

        const majorProblemsResponse = await this.http.get(
          `${environment.API_URL}${RESULT_STORE_ENPOINTS.FEEDBACK_MAJOR_PROBLEMS_FREQUENCY}?from=${from}`
        ).toPromise();

        resolve({
          wasHelpful: (wasHelpfulResponse as any).reduce((obj, item) => Object.assign(obj, { [item.wasHelpful]: item.percent }), {}),
          uiIsGood: (uiIsGoodResponse as any).reduce((obj, item) => Object.assign(obj, { [item.uiIsGood]: item.percent }), {}),
          iWillUseIt: (iWillUseItResponse as any).reduce((obj, item) => Object.assign(obj, { [item.iWillUseIt]: item.percent }), {}),
          majorProblems: (majorProblemsResponse as any)
            .reduce((obj, item) => Object.assign(obj, { [item.majorProblem]: item.percent }), {}),
        });

      } catch (reason) {
        console.log(reason);
        reject(false);
      }
    });
  }

  getFeedback() {
    this.http.get(environment.API_URL + '/feedbacks', { withCredentials: true }).toPromise().then((res: any) => {
      this.feedback = res;
      console.log(res);
    }).catch((reason) => this.authenticated = false);
  }

  deleteFeedback(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete(`${environment.API_URL}/feedbacks/${id}`, { withCredentials: true }).toPromise().then((res: any) => {
        this.getFeedback();
        resolve(true);
      }).catch((reason) => resolve(false));
    });
  }


  getFileURL(feedbackID: string, filename: string) {
    return environment.API_URL + '/feedbacks/' + feedbackID + '/' + filename;
  }


  logout() {
    this.http.get(`${environment.API_URL}/auth/logout`, { withCredentials: true }).toPromise().then((res: any) => {
      this.authenticated = false;
      this.user = undefined;
    });
  }
}
